var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PrettyListItemMenu',{attrs:{"items":_vm.prettyListItems},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(bindings){return [_vm._t("activator",null,null,bindings)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }